import * as actionTypes from "../action-types";
export const authLogin = (payload) => ({
    type: actionTypes.AUTH_LOGIN,
    payload,
});

export const authLogout = (payload) => ({
    type: actionTypes.AUTH_LOGOUT,
    payload,
});

export const updateUserInfo = (payload) => ({
    type: actionTypes.UPDATE_USER_INFO,
    payload,
});

export const updateSettingWidget = (payload) => ({
    type: actionTypes.SETTING_WIDGET,
    payload,
});

export const updateSettingDiscount = (payload) => ({
    type: actionTypes.SETTING_DISCOUNT,
    payload,
});
